<app-floorplan-item-details
  [extent]="extent()"
  [isExtendable]="true"
  [floorplanItem]="flameDetector()"
  [productId]="flameDetector().config.mainProductId"
  [showDiscontinuedWarning]="isDiscontinued()"
  [showIncompleteWarning]="isIncompleteConfiguration()"
  (toggleExtendedButtonClicked)="toggleExtendedButtonClicked.emit()"
>
  <div data-main>
    @if (substanceName$ | async; as substanceName) {
      <div class="feature">
        <p class="odx-text--small" i18n="@@floorplan.details.flameDetector.substance">Substanzart</p>
        <p>{{ substanceName }}</p>
      </div>
    }

    <app-floorplan-item-attachments-button
      [productItems]="productItems()"
      [attachments]="attachments()"
      [customProducts]="flameDetector().products"
      [gasId]="flameDetector().config.substanceId"
    ></app-floorplan-item-attachments-button>
    <app-floorplan-item-group [floorplanItem]="flameDetector()"></app-floorplan-item-group>
  </div>
  @if (extent() !== SidesheetExtent.None) {
    <div data-extended>
      <app-floorplan-flame-detector-detail-form [flameDetector]="flameDetector()"></app-floorplan-flame-detector-detail-form>
    </div>
  }
</app-floorplan-item-details>
